import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'handleAdjustOrderInProgress',
  initialState: false,
  reducers: {
    setHandleAdjustOrderInProgress(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setHandleAdjustOrderInProgress } = slice.actions;

export default slice.reducer;
